import { SCORE_DECIMAL_PLACES } from '../calibrationConstants';

import { formatDecimal } from '@/utils/numberFormat';

export interface FormatScoreOptions {
    value: number;
    language: string;
}

/**
 * Formats a calibration score (0-100) in the given language, always with one decimal: `78,4` /
 * `72,0` (fr), `78.4` / `72.0` (en). The fixed decimal matters wherever scores are read as a
 * column — a "72" between a "85,7" and a "61,3" reads as a different kind of number.
 */
export const formatScore = ({ value, language }: FormatScoreOptions): string =>
    formatDecimal(value, language, { fractionDigits: SCORE_DECIMAL_PLACES });
